<template>
  <el-popover :disabled="popoverDisabled" placement="top-start" trigger="hover">
    <template #reference>
      <el-tooltip
        :disabled="!mainIconParams.tooltip"
        effect="dark"
        placement="top-start"
        :content="mainIconParams.tooltip"
      >
        <img :src="mainIconParams.icon" alt="Countries" width="20px;" />
      </el-tooltip>
    </template>
    {{ mainIconParams.description }}
  </el-popover>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'
import tablet from '@/apps/traforama/assets/icons/tablet.png'
import otherDevice from '@/apps/traforama/assets/icons/other_device.png'
import mobile from '@/apps/traforama/assets/icons/mobile.png'
import desktop from '@/apps/traforama/assets/icons/desktop.png'

const ICONS: Record<number, string> = {
  1: desktop,
  2: mobile,
  3: tablet
}

const DESCRIPTIONS: Record<number, string> = {
  1: 'Desktop',
  2: 'Mobile',
  3: 'Tablet',
  4: 'Console',
  5: 'TV',
  6: 'Wearable'
}

export default defineComponent({
  name: 'DevicesIcon',
  props: {
    deviceIds: {
      type: Array as PropType<number[]>,
      required: true
    }
  },
  setup(props) {
    const popoverDisabled = computed(() => {
      return !props.deviceIds.length || props.deviceIds.length === 1
    })

    const getDeviceIcon = (id: number) => {
      return ICONS[id] || otherDevice
    }

    const getDescription = () => {
      return props.deviceIds.map((id: number) => DESCRIPTIONS[id]).join(', ')
    }

    const mainIconParams = computed(() => {
      if (!props.deviceIds.length) {
        return { icon: otherDevice, tooltip: 'All devices' }
      } else if (props.deviceIds.length === 1) {
        return {
          icon: getDeviceIcon(props.deviceIds[0]),
          tooltip: DESCRIPTIONS[props.deviceIds[0]]
        }
      } else {
        return { icon: otherDevice, description: getDescription() }
      }
    })

    return { mainIconParams, popoverDisabled }
  }
})
</script>
